import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "navbar navbar-expand-md navbar-dark custom-navbar" }
const _hoisted_3 = { class: "navbar-brand-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "navbar-brand company-name" }
const _hoisted_6 = { class: "navbar-nav main-nav" }
const _hoisted_7 = {
  key: 0,
  class: "badge bg-danger ms-1"
}
const _hoisted_8 = { class: "sidebar-content" }
const _hoisted_9 = { class: "sidebar-content" }
const _hoisted_10 = {
  key: 0,
  class: "badge bg-danger ms-1"
}
const _hoisted_11 = { class: "sidebar-content" }
const _hoisted_12 = { class: "sidebar-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.companyIconFileName,
          class: "company-logo",
          alt: "Logo"
        }, null, 8, _hoisted_4),
        _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.companyName), 1)
      ]),
      _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mobileNavOpen = !_ctx.mobileNavOpen))
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)
      ]))]),
      _createElementVNode("div", {
        class: _normalizeClass(["collapse navbar-collapse", { show: _ctx.mobileNavOpen }]),
        id: "navbarNavAltMarkup"
      }, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createVNode(_component_router_link, {
            class: "nav-link",
            to: "/expiryDatesScan",
            onClick: _ctx.closeMobileMenus
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createElementVNode("svg", {
                class: "nav-icon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", { d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" })
              ], -1),
              _createTextVNode(" Dashboard ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.isLoggedIn]
          ]),
          _withDirectives(_createVNode(_component_router_link, {
            class: "nav-link",
            to: "/login",
            onClick: _ctx.closeMobileMenus
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createElementVNode("svg", {
                class: "nav-icon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", { d: "M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" })
              ], -1),
              _createTextVNode(" Login ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, !_ctx.isLoggedIn]
          ]),
          _withDirectives(_createVNode(_component_router_link, {
            class: "nav-link",
            to: "/schedule",
            onClick: _ctx.closeMobileMenus
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createElementVNode("svg", {
                class: "nav-icon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", { d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" })
              ], -1),
              _createTextVNode(" Schedule ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.isLoggedIn]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["nav-item dropdown", { 'show': _ctx.openMobileMenus.includes('officers') }])
          }, [
            _createElementVNode("a", {
              class: "nav-link dropdown-toggle",
              href: "#",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleMenu('officers')), ["prevent"]))
            }, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("svg", {
                class: "nav-icon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", { d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" })
              ], -1),
              _createTextVNode(" Officers ", -1)
            ]))]),
            _createElementVNode("div", {
              class: _normalizeClass(["dropdown-menu mobile-accordion", { 'show': _ctx.openMobileMenus.includes('officers') }])
            }, [
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/securityOfficers",
                onClick: _ctx.closeMobileMenus
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("Officers List", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/officerGroups",
                onClick: _ctx.closeMobileMenus
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("Officer Groups", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/securityOfficerLogins",
                onClick: _ctx.closeMobileMenus
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("Officer Logins", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/banOfficerForSite",
                onClick: _ctx.closeMobileMenus
              }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode("Ban (Site)", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/banOfficerForClient",
                onClick: _ctx.closeMobileMenus
              }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode("Ban (Client)", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ], 2)
          ], 2), [
            [_vShow, _ctx.isLoggedIn]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["nav-item dropdown", { 'show': _ctx.openMobileMenus.includes('directory') }])
          }, [
            _createElementVNode("a", {
              class: "nav-link dropdown-toggle",
              href: "#",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleMenu('directory')), ["prevent"]))
            }, [...(_cache[17] || (_cache[17] = [
              _createElementVNode("svg", {
                class: "nav-icon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", { d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" })
              ], -1),
              _createTextVNode(" Management ", -1)
            ]))]),
            _createElementVNode("div", {
              class: _normalizeClass(["dropdown-menu mobile-accordion", { 'show': _ctx.openMobileMenus.includes('directory') }])
            }, [
              (_ctx.isBossUser)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "dropdown-item",
                    to: "/analysis",
                    onClick: _ctx.closeMobileMenus
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createTextVNode("Analysis", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isBossUser)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    class: "dropdown-item",
                    to: "/adminUsers",
                    onClick: _ctx.closeMobileMenus
                  }, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createTextVNode("Manage Admins", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/companies",
                onClick: _ctx.closeMobileMenus
              }, {
                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                  _createTextVNode("Clients", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/sites",
                onClick: _ctx.closeMobileMenus
              }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createTextVNode("Sites", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/cities",
                onClick: _ctx.closeMobileMenus
              }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode("Cities", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/branches",
                onClick: _ctx.closeMobileMenus
              }, {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createTextVNode("Branches", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              (_ctx.isBossUser)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    class: "dropdown-item",
                    to: "/companySettings",
                    onClick: _ctx.closeMobileMenus
                  }, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createTextVNode("Company Settings", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isApprover)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 3,
                    class: "dropdown-item",
                    to: "/holidayRequests",
                    onClick: _ctx.closeMobileMenus
                  }, {
                    default: _withCtx(() => [
                      _cache[25] || (_cache[25] = _createTextVNode(" Holiday Requests ", -1)),
                      (_ctx.pendingApprovalsCount > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.pendingApprovalsCount), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isEventsUser)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 4,
                    class: "dropdown-item",
                    to: "/events",
                    onClick: _ctx.closeMobileMenus
                  }, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                      _createTextVNode("Events", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ], 2)
          ], 2), [
            [_vShow, _ctx.isLoggedIn]
          ]),
          _withDirectives(_createVNode(_component_router_link, {
            class: "nav-link",
            to: "/jobCalls",
            onClick: _ctx.closeMobileMenus
          }, {
            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
              _createElementVNode("svg", {
                class: "nav-icon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", { d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" })
              ], -1),
              _createTextVNode(" Calls ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.isLoggedIn]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["nav-item dropdown", { 'show': _ctx.openMobileMenus.includes('payroll') }])
          }, [
            _createElementVNode("a", {
              class: "nav-link dropdown-toggle",
              href: "#",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.toggleMenu('payroll')), ["prevent"]))
            }, [...(_cache[28] || (_cache[28] = [
              _createElementVNode("svg", {
                class: "nav-icon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", { d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" })
              ], -1),
              _createTextVNode(" Finance ", -1)
            ]))]),
            _createElementVNode("div", {
              class: _normalizeClass(["dropdown-menu mobile-accordion", { 'show': _ctx.openMobileMenus.includes('payroll') }])
            }, [
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/pays",
                onClick: _ctx.closeMobileMenus
              }, {
                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                  _createTextVNode("Pays", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/updatePayRates",
                onClick: _ctx.closeMobileMenus
              }, {
                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                  _createTextVNode("Pay Rates", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ], 2)
          ], 2), [
            [_vShow, _ctx.isLoggedIn]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["nav-item dropdown", { 'show': _ctx.openMobileMenus.includes('account') }])
          }, [
            _createElementVNode("a", {
              class: "nav-link dropdown-toggle",
              href: "#",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.toggleMenu('account')), ["prevent"]))
            }, [...(_cache[31] || (_cache[31] = [
              _createElementVNode("svg", {
                class: "nav-icon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("path", { d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" }),
                _createElementVNode("path", { d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z" })
              ], -1),
              _createTextVNode(" Account ", -1)
            ]))]),
            _createElementVNode("div", {
              class: _normalizeClass(["dropdown-menu mobile-accordion", { 'show': _ctx.openMobileMenus.includes('account') }])
            }, [
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/changepassword",
                onClick: _ctx.closeMobileMenus
              }, {
                default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                  _createTextVNode("Password", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/logout",
                onClick: _ctx.closeMobileMenus
              }, {
                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                  _createTextVNode("Logout", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ], 2)
          ], 2), [
            [_vShow, _ctx.isLoggedIn]
          ])
        ])
      ], 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["desktop-sidebar", { 'active': _ctx.activeDesktopMenu !== '' }]),
      onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hideDesktopMenu && _ctx.hideDesktopMenu(...args)))
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, {
          class: "sidebar-item",
          to: "/securityOfficers"
        }, {
          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
            _createTextVNode("Officers List", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "sidebar-item",
          to: "/officerGroups"
        }, {
          default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
            _createTextVNode("Officer Groups", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "sidebar-item",
          to: "/securityOfficerLogins"
        }, {
          default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
            _createTextVNode("Officer Logins", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "sidebar-item",
          to: "/banOfficerForSite"
        }, {
          default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
            _createTextVNode("Ban (Site)", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "sidebar-item",
          to: "/banOfficerForClient"
        }, {
          default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
            _createTextVNode("Ban (Client)", -1)
          ]))]),
          _: 1
        })
      ], 512), [
        [_vShow, _ctx.activeDesktopMenu === 'officers']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        (_ctx.isBossUser)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "sidebar-item",
              to: "/analysis"
            }, {
              default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                _createTextVNode("Analysis", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isBossUser)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: "sidebar-item",
              to: "/adminUsers"
            }, {
              default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                _createTextVNode("Manage Admins", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          class: "sidebar-item",
          to: "/companies"
        }, {
          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
            _createTextVNode("Clients", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "sidebar-item",
          to: "/sites"
        }, {
          default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
            _createTextVNode("Sites", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "sidebar-item",
          to: "/cities"
        }, {
          default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
            _createTextVNode("Cities", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "sidebar-item",
          to: "/branches"
        }, {
          default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
            _createTextVNode("Branches", -1)
          ]))]),
          _: 1
        }),
        (_ctx.isBossUser)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              class: "sidebar-item",
              to: "/companySettings"
            }, {
              default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                _createTextVNode("Company Settings", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isApprover)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              class: "sidebar-item",
              to: "/holidayRequests"
            }, {
              default: _withCtx(() => [
                _cache[46] || (_cache[46] = _createTextVNode(" Holiday Requests ", -1)),
                (_ctx.pendingApprovalsCount > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.pendingApprovalsCount), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isEventsUser)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 4,
              class: "sidebar-item",
              to: "/events"
            }, {
              default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                _createTextVNode("Events", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, _ctx.activeDesktopMenu === 'directory']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        _createVNode(_component_router_link, {
          class: "sidebar-item",
          to: "/pays"
        }, {
          default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
            _createTextVNode("Pays", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "sidebar-item",
          to: "/updatePayRates"
        }, {
          default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
            _createTextVNode("Pay Rates", -1)
          ]))]),
          _: 1
        })
      ], 512), [
        [_vShow, _ctx.activeDesktopMenu === 'payroll']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _createVNode(_component_router_link, {
          class: "sidebar-item",
          to: "/changepassword"
        }, {
          default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
            _createTextVNode("Password", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "sidebar-item",
          to: "/logout"
        }, {
          default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
            _createTextVNode("Logout", -1)
          ]))]),
          _: 1
        })
      ], 512), [
        [_vShow, _ctx.activeDesktopMenu === 'account']
      ])
    ], 34),
    _createElementVNode("div", {
      class: "main-content",
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hideDesktopMenu && _ctx.hideDesktopMenu(...args)))
    }, [
      _createVNode(_component_router_view)
    ])
  ]))
}